module.exports = __webpack_public_path__ + "static/img/image.6384b719.jpg";